import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@auth0/auth0-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { distinct, filter, switchMap } from 'rxjs';
import { TextNotificationService } from '../../common-app/services/text-notification.service';
import { BridgeTokenService } from '../../security/services/bridge-token.service';
import { SECURITY_MODULE_CONFIG, SecurityModuleConfig } from '../../security/security-config';



@Component({
  selector: 'app-bridge',
  templateUrl: './bridge.component.html',
  styleUrls: ['./bridge.component.scss'],
})
export class BridgeComponent implements OnInit, OnDestroy {

  constructor(
    @Inject(SECURITY_MODULE_CONFIG) private config: SecurityModuleConfig,
    private auth: AuthService,
    private bridgeTokenService: BridgeTokenService,
    private textNotificationService: TextNotificationService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }


  ngOnDestroy(): void {
    this.spinner.hide();
  }

  ngOnInit(): void {
    this.spinner.show();
    this.auth.isLoading$.pipe(
      filter(isLoading => !isLoading),
      distinct(),
      switchMap(() =>
        this.auth.isAuthenticated$.pipe(
          filter(isAuth => isAuth),
          switchMap(() =>  this.auth.getAccessTokenSilently())
        ))).subscribe({
          next: (token: string) => {
            if (token) {
              this.bridgeTokenService.externalToken(token);
            } else {
              this.textNotificationService.error('No se recibió token desde Auth0');
              this.spinner.hide();
            }
          },
          error: (err: any) => {
            this.spinner.hide();
            this.textNotificationService.error(err?.message ?? 'Error obteniendo token');
          }
        });
    this.auth.error$.subscribe({
      next: (err) => {
        this.spinner.hide();
        this.textNotificationService.error(err?.message ?? 'Error en autenticación');
      }
    }

    )
    this.bridgeTokenService.getToken().subscribe({
      next: () => {
        this.textNotificationService.text("Security config success");
        this.router.navigate([this.config.postAuthUrls]);
      },
      error: (error) => {
        if (error.status !== undefined && error.status === 401) {
          this.textNotificationService.error('Login failed');
        } else {
          this.textNotificationService.error(error.message);
        }

      }
    });
  }

}
